(function () {
  angular
    .module("akitabox.serviceRequest.list")
    .controller("ServiceRequestListController", ServiceRequestListController);

  /* @ngInject */
  function ServiceRequestListController(
    // Angular
    $location,
    $scope,
    $state,
    // Services
    models,
    RequestService,
    // Resolve
    building,
    query,
    status
  ) {
    var self = this;

    var filter = RequestService.getBuildingListFilter(building._id) || {};

    var baseQuery = {
      open: {
        status: "$in,open,new",
      },
      closed: {
        status: "$in,completed,denied",
      },
    };

    // Attributes
    self.building = building;
    self.activeTab = status === "closed" ? 1 : 0;
    self.requests = {};
    self.searchText = null;

    // Functions
    self.getStatusClass = getStatusClass;
    self.onSelectTab = onSelectTab;
    self.selectRequest = selectRequest;
    self.hasLoadedOpen = hasLoadedOpen;
    self.hasLoadedClosed = hasLoadedClosed;
    self.emptyOpenList = emptyOpenList;
    self.emptyClosedList = emptyClosedList;
    self.addWorkOrder = addWorkOrder;
    self.addServiceRequest = addServiceRequest;

    init();

    function init() {
      // Initialize search. Default to querystring, then cached filter
      self.searchText = query ? query : filter.q;
      fetchRequests(self.searchText);
      self.searchOpen = !angular.isEmpty(self.searchText);
      // Watch search text
      $scope.$watch("vm.searchText", angular.debounce(onSearchTextChange, 500));
    }

    function onSearchTextChange(newValue, oldValue) {
      if (newValue !== oldValue) fetchRequests(newValue);
    }

    function updateFilter(params) {
      filter = angular.extend(filter, params);
      RequestService.setBuildingListFilter(building._id, filter);
    }

    function fetchRequests(text) {
      $location.search("q", text);
      updateFilter({ q: text });
      var openParams = angular.extend({}, baseQuery.open, filter);
      var closedParams = angular.extend({}, baseQuery.closed, filter);
      var queryParams =
        "_number=" +
        filter.q +
        ";subject=" +
        filter.q +
        ";description=" +
        filter.q;

      if (filter.q) {
        openParams.$or = queryParams;
        closedParams.$or = queryParams;
        delete openParams.q;
        delete closedParams.q;
      }

      self.requests.open = RequestService.getVirtualRepeat(
        building._id,
        10,
        openParams
      );
      self.requests.closed = RequestService.getVirtualRepeat(
        building._id,
        10,
        closedParams
      );
    }

    function addServiceRequest() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.serviceRequests.create", params);
    }

    function addWorkOrder() {
      var params = {};

      params[models.BUILDING.ROUTE_SINGULAR] = self.building._id;

      $state.go("app.workOrders.create", params);
    }

    /**
     * Retrieve class for work order status (warn, success, etc.)
     *
     * @param  {Object} request   Work order
     * @return {String}             Class name
     */
    function getStatusClass(request) {
      var status = request ? request.status : null;

      switch (status) {
        case "new":
          return "fg-warn";
        case "open":
          return "fg-success";
        case "denied":
          return "fg-dark";
        case "completed":
          return "fg-dark";
        default:
          return "fg-black";
      }
    }

    /**
     * Handle tab selection, update URL status query
     *
     * @param {String} tab Tab name (open, closed)
     */
    function onSelectTab(tab) {
      $location.search("status", tab);
    }

    /**
     * Navigate to work order details
     *
     * @param {Object} request    The selected work order
     */
    function selectRequest(request) {
      $state.go("app.building.serviceRequest.detail", {
        buildingId: self.building._id,
        requestId: request._id,
      });
    }

    function hasLoadedOpen() {
      return angular.isNumber(self.requests.open.numItems);
    }

    function hasLoadedClosed() {
      return angular.isNumber(self.requests.closed.numItems);
    }

    function emptyOpenList() {
      return (
        self.requests.open.getLength() === 0 &&
        !self.requests.open.moreToLoad &&
        !self.requests.open.fetching
      );
    }

    function emptyClosedList() {
      return (
        self.requests.closed.getLength() === 0 &&
        !self.requests.closed.moreToLoad &&
        !self.requests.closed.fetching
      );
    }
  }
})();
